import React from 'react';
import HomeCont from './components/HomeCont';

function HomePage() {
    return <HomeCont />;
}

export default HomePage;
